<template>
    <div>

        <form @submit.prevent="setForm()">
            <div class="form-group mb-6">
                <label class="form-label" for="mail_name_input">
                    Nombre
                </label>
                <input required :class="err['name'] ? 'border-red' : ''" id="mail_name_input" name="mail_name_input" class="form-input" type="text" v-model="name">
            </div>
            <div class="form-grid">
                <div class="form-group sm:col-8 mb-6">
                    <label class="form-label" for="mail_email_input">
                        Email
                    </label>
                    <input required :class="err['email'] ? 'border-red' : ''" class="form-input" type="email" name="mail_email_input" id="mail_email_input" v-model="email">
                </div>
                <div class="form-group sm:col-8 mb-6">
                    <label class="form-label" for="mail_phone_input">
                        Celular
                    </label>
                    <input required :class="err['phone'] ? 'border-red' : ''" class="form-input" type="tel" name="mail_phone_input" id="mail_phone_input" v-model="phone">
                </div>
            </div>
            <div class="form-group mb-6">
                <label class="form-label" for="mail_content_input">
                    Tu pregunta
                </label>
                <textarea required :class="err['content'] ? 'border-red' : ''" class="form-input resize-none" name="mail_content_input" id="mail_content_input" cols="30" rows="5" v-model="content"></textarea>
            </div>
            <input class="btn btn--green-ad btn--send" type="submit" value="Enviar mensaje al vendedor">
        </form>

    </div>
</template>
<script>

import { mapState } from 'vuex';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export default  {
    props: ['product_id'],

    data: () => ({
        formData: null,
        name: null,
        email: null,
        content: null,
        phone: null,
        err: []
    }),

    watch: {

        user(state) {
            let vm = this;
            if ( state.id !== undefined ) {
                vm.name     = state.name + ' ' + state.last_name;
                vm.email    = state.email;
                vm.phone    = state.phone;
                vm.user_id  = state.id;
            }
        }

    },

    computed: { ...mapState(['user']) },

    methods: {
        async setForm(event) {
            let vm = this;
            vm.formData = new FormData();
            vm.err      = [];

            vm.$swal({
                icon: "info",
                title: "Enviando correo...",
                text: "Espere un momento",
            });

            vm.formData.append('name', vm.name);
            vm.formData.append('email', vm.email);
            vm.formData.append('phone', vm.phone);
            vm.formData.append('content', vm.content);
            vm.formData.append('product_id', vm.product_id);
            vm.formData.append('user_id', vm.user_id ? vm.user_id : 0);

            let data = await axios.post('/client/modules/maxipublica-mail', vm.formData)
            .then(response => {
                vm.$swal({
                    icon: "success",
                    title: "Correo enviado",
                    text: "Gracias",
                    confirmButtonText: 'Aceptar'
                }).then((result) => {
                    if(result){
                        //window.location.href = 'car/' + vm.product.id;
                    }
                });
            }).catch(error => {
                vm.err = error.response.data.errors;
            });

            if( vm.err.length > 0 ) {
                vm.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: vm.err['message'] ? vm.err['message'] : 'Se encontraron algunos errores.',
                    confirmButtonText: 'Aceptar'
                });
            }

        }
    }


}
</script>
